import { HelpCircle, Mail, Phone, FileText } from "lucide-react";

const faqs = [
  { q: "How do I download an invoice?", a: "Navigate to the Transactions page, find your transaction, and click the download button next to invoices marked as \"Available\"." },
  { q: "What does \"Pending\" status mean?", a: "Pending invoices are currently being processed and will be available for download once ready." },
  { q: "How do I raise an amendment request?", a: "Go to the Requests page and click \"New Request\". Select the request type and provide details. Our team will process it within 2 business days." },
  { q: "What is a B2C to B2B conversion?", a: "If your booking was made under an individual (B2C) instead of your company (B2B), you can request a conversion to get a proper corporate tax invoice with GSTIN." },
  { q: "How do I update my GSTIN?", a: "Submit a GSTIN Mismatch request via the Requests page. Provide the correct GSTIN and our team will update the invoice accordingly." },
  { q: "How long does invoice processing take?", a: "Tax invoices are typically processed within 4 business days of your travel date." },
];

export default function HelpPage() {
  return (
    <div className="p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-semibold text-gray-900 mb-2">Help Center</h1>
        <p className="text-gray-500 mb-8">Get support and find answers to common questions</p>

        {/* Contact cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="w-12 h-12 bg-[#367588]/10 rounded-lg flex items-center justify-center mb-4">
              <Mail className="w-6 h-6 text-[#367588]" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">Email Support</h3>
            <p className="text-sm text-gray-500 mb-3">Get help via email</p>
            <a href="mailto:support@vietnamairlines.com" className="text-sm text-[#367588] hover:underline">support@vietnamairlines.com</a>
          </div>

          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="w-12 h-12 bg-[#367588]/10 rounded-lg flex items-center justify-center mb-4">
              <Phone className="w-6 h-6 text-[#367588]" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">Phone Support</h3>
            <p className="text-sm text-gray-500 mb-3">Call us for assistance</p>
            <a href="tel:+842438320320" className="text-sm text-[#367588] hover:underline">+84 24 3832 0320</a>
          </div>

          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="w-12 h-12 bg-[#367588]/10 rounded-lg flex items-center justify-center mb-4">
              <FileText className="w-6 h-6 text-[#367588]" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">Documentation</h3>
            <p className="text-sm text-gray-500 mb-3">Browse user guides</p>
            <a href="#" className="text-sm text-[#367588] hover:underline">View Documentation</a>
          </div>
        </div>

        {/* FAQs */}
        <div className="bg-white rounded-lg border border-gray-200 p-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-6">Frequently Asked Questions</h2>
          <div className="space-y-6">
            {faqs.map((f, i) => (
              <div key={i} className={i > 0 ? "border-t border-gray-100 pt-6" : ""}>
                <div className="flex items-start gap-3">
                  <HelpCircle className="w-5 h-5 text-[#367588] flex-shrink-0 mt-0.5" />
                  <div>
                    <h3 className="font-medium text-gray-900 mb-2">{f.q}</h3>
                    <p className="text-sm text-gray-600">{f.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
